import { management } from '../../../index';

export class GetsSectorSensorsName {
  // Get data needed to build the history of management sector graphic
  async execute(ID_SECTOR) {
    const raw = `
      SELECT 
        CAD_SENSOR.NAME SENSOR_NAME
      FROM NEWSIR.SECTOR_HAS_SENSOR SECTOR_SENSOR
      LEFT JOIN NEWSIR.CAD_SENSOR CAD_SENSOR
      ON CAD_SENSOR.ID = SECTOR_SENSOR.ID_SENSOR
      LEFT JOIN NEWSIR.CAD_MODEL_SENSOR MODEL_SENSOR
      ON MODEL_SENSOR.ID = CAD_SENSOR.FK_MODEL 
      WHERE (
          ID_SECTOR = ${ID_SECTOR}
          AND ( 
            MODEL_SENSOR.NAME LIKE 'GS1%' 
            OR MODEL_SENSOR.NAME LIKE 'GS3%' 
            OR MODEL_SENSOR.NAME LIKE 'TEROS10%' 
            OR MODEL_SENSOR.NAME LIKE 'TEROS12%' 
            OR MODEL_SENSOR.NAME LIKE 'STU-S%' )
        );
    `;

    const baseResult = await management
      .sql({
        data: {
          sql: raw
        }
      })
      .then(r => r && r[0])

    return baseResult;
  }
}